export default {
  SET_SURVEYS(state, surveys) {
    state.surveys = surveys;
  },
  SET_SURVEY_ANSWER_YN(state, surveyAnswerYn) {
    state.surveyAnswerYn = surveyAnswerYn;
  },
  SET_SELECT_SURVEY(state, survey) {
    state.selectSurvey = survey;
  },
  SET_VALIDATE_YN(state, validateYn) {
    state.validateYn = validateYn;
  },
  SET_SURVEY_QUESTIONS(state, surveyQuestions) {
    state.surveyQuestions = surveyQuestions.map(surveyQuestion => {
      surveyQuestion.selectSurveyAnswers = [];
      surveyQuestion.essayAnswer = "";

      surveyQuestion.surveyQuestionAnswers.forEach(surveyQuestionAnswer => {
        surveyQuestionAnswer.addSurveyQuestions.forEach(surveyQuestion => {
          surveyQuestion.selectSurveyAnswers = [];
          surveyQuestion.essayAnswer = "";
        })
      })
      return surveyQuestion;
    });
  },
  SET_GUEST_SURVEY(state, survey) {
    state.selectGuestSurvey = survey;
  },
};



// WEBPACK FOOTER //
// ./src/store/survey/mutations.js